import { config as appConfig } from "../../services/config";

export const BACKEND = appConfig.URL_API.replace("/api", "");

export const RAD_MAP = { none: 0, sm: 4, md: 8, full: 24 };

export const resolveRad = (radius, fallback = 8) => RAD_MAP[radius] ?? fallback;

export const resolveImgUrl = (url) => {
  if (!url) return null;
  return url.startsWith("http") ? url : BACKEND + url;
};

export const loadGoogleFont = (fontStr) => {
  const match = fontStr?.match(/'([^']+)'/);
  if (!match) return;
  const name = match[1];
  const id = `gf-${name.replace(/\s/g, "-").toLowerCase()}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${name.replace(/\s/g, "+")}:wght@400;500;600;700;800&display=swap`;
  document.head.appendChild(link);
};
